import cookie from '../cookie';
import { getCurrentDomain } from '../host';
import { SearchParamSaversManager } from './searchParamSaverManager';
import { hasCookieConsentCategory } from '../cookieConsent';

const SEARCH_PARAM_SAVERS = [
  {
    name: 'li_fat_id',
    searchKeys: ['li_fat_id'],
    lifetimeMs: 2 * 60 * 60 * 1000, // 2 hours
    cookieCondition: () => hasCookieConsentCategory('marketing'),
    allowCookie: true,
  },
  {
    name: 'utm_parameters',
    searchKeys: [
      'utm_source',
      'utm_medium',
      'utm_campaign',
      'utm_term',
      'utm_content',
    ],
    lifetimeMs: 2 * 60 * 60 * 1000, // 2 hours
    cookieCondition: () => hasCookieConsentCategory('marketing'),
    override: {
      utm_source: {
        value: () => {
          const EXCLUDE_DOMAINS = ['any.run', 'calendly.com', 'paddle.com', 'susp.io'];
          const pageReferrer = document?.referrer || null;

          if (!pageReferrer) return null;

          const url = new URL(pageReferrer);
          const { hostname } = url;
          const parts = hostname.split('.');
          const domain = parts.length > 2 ? parts.slice(-2).join('.') : hostname;

          if (EXCLUDE_DOMAINS.includes(domain)) return;

          return pageReferrer;
        }
      },
    },
    allowCookie: true,
  },
  {
    name: 'gclid',
    searchKeys: ['gclid'],
    lifetimeMs: 2 * 60 * 60 * 1000, // 2 hours
  },
];

export const searchParamSaversManager = new SearchParamSaversManager(
  SEARCH_PARAM_SAVERS
);

export const searchParams = {
  get linkedin() {
    const linkedinSearchParamsSaver = searchParamSaversManager.get('li_fat_id');
    const params = linkedinSearchParamsSaver?.getParams();

    const liFatId = params?.li_fat_id || null;

    return { li_fat_id: liFatId };
  },
  get utm() {
    const utmSearchParamsSaver = searchParamSaversManager.get('utm_parameters');
    const params = utmSearchParamsSaver?.getParams();

    const utmCampaign = params?.utm_campaign || null;
    const utmSource = params?.utm_source || null;

    return {
      utm_source: utmCampaign,
      utm_campaign: utmSource,
    };
  },
  get googleAds() {
    const paramFromCookie = cookie.get('FPGCLAW', {
      domain: getCurrentDomain(),
    });

    const searchParamsSaver = searchParamSaversManager.get('gclid');
    const params = searchParamsSaver?.getParams();

    const gclid = paramFromCookie || params?.gclid || null;

    return { gclid };
  },
};
